/**
 * Позволяет при изменении Union типов поймать места где необходимо обработать новые варианты в if-else и switch конструкциях
 * @param arg
 */
export function shouldNeverHappen(arg: never, message?: string): asserts arg is never {
  throw new Error(message);
}
